/** Strategem 55 (Vein Sever) — slash overlay lifetime */
export const VEIN_SEVER_SLASH_DURATION_MS = 920;
